import { Button, Container } from "@material-ui/core"
import { CategoryResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import React, { useEffect, useState } from "react"
import { InView } from "react-intersection-observer"
import styled from "styled-components"
import colors from "theme/colors"
import CategoryImageSlider from "./CategoryImageSlider"
import CategoryName from "./CategoryName"

const StyledWrapper = styled(Container)`
  background-color: ${colors.white};
  margin-top: 50px;
  overflow: hidden;

  max-width: none;
  padding: 0 60px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 30px;
    padding-right: 16px;
    padding: 0px;
  }
`

const StyledButton = styled(Button).attrs({ variant: "contained" })`
  height: 56px;
  background-color: ${colors.darkYellow};
  color: ${colors.black};
  margin-bottom: 60px;
`
const StyledDivWrapper = styled.div<{ $visible: boolean }>`
  visibility: hidden;
`

type CategoriesProps = {
  divRef: React.Ref<HTMLDivElement>
  categoriesData: CategoryResponse[]
  scrollRef: React.Ref<HTMLDivElement>
  isHomePage?: boolean
}

const Categories = ({
  divRef,
  categoriesData,
  scrollRef,
  isHomePage,
}: CategoriesProps) => {
  const [showMore, setShowMore] = useState(false)
  const [dataToShow, setDataToShow] = useState<CategoryResponse[]>([])
  const isDesktop = useIsDesktop()

  useEffect(() => {
    if (isDesktop) {
      const sliceCount = showMore ? categoriesData.length : 5
      setDataToShow(categoriesData.slice(0, sliceCount))
    } else {
      setDataToShow(categoriesData)
    }
  }, [showMore, categoriesData, isDesktop])

  return (
    <>
      <StyledWrapper ref={divRef}>
        <div ref={scrollRef} tabIndex={-1}>
          {dataToShow.map((data, index) => {
            if (data?.blessing.length === 0) return

            // Used on HomePage
            if (isHomePage && index > 0) return

            return (
              <InView key={index}>
                {({ inView, ref }) => (
                  <CategoryInView
                    key={index}
                    data={data}
                    scrollRef={ref}
                    inView={inView}
                    isHomePage={isHomePage}
                  />
                )}
              </InView>
            )
          })}
        </div>
      </StyledWrapper>
      {!isHomePage && categoriesData?.length > 5 && isDesktop && !showMore && (
        <StyledButton onClick={() => setShowMore(true)}>
          צפייה בקטגוריות נוספות
        </StyledButton>
      )}
    </>
  )
}

const CategoryInView = ({
  data,
  scrollRef,
  inView,
  isHomePage,
}: {
  data: CategoryResponse
  inView: boolean
  scrollRef: any
  isHomePage?: boolean
}) => {
  return (
    <StyledDivWrapper ref={scrollRef} $visible={inView}>
      <CategoryName
        categoryName={data?.name}
        bonusText={data?.categoryPromotion?.name}
        slug={data?.slug}
        inView={inView}
      />
      <CategoryImageSlider
        inView={inView}
        blessing={data?.blessing.sort((a, b) => a.order - b.order)}
        bonusText={data?.categoryPromotion?.name}
        categoryName={data?.name}
        isHomePage={isHomePage}
      />
    </StyledDivWrapper>
  )
}

export default Categories
